import { render, staticRenderFns } from "./goodsExport.vue?vue&type=template&id=5af3f2d4&scoped=true"
import script from "./goodsExport.vue?vue&type=script&lang=js"
export * from "./goodsExport.vue?vue&type=script&lang=js"
import style0 from "./goodsExport.vue?vue&type=style&index=0&id=5af3f2d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af3f2d4",
  null
  
)

export default component.exports